module.exports = __webpack_public_path__ + "media/images/app/trust/iconTwo-ee4d95f737e345fda44898562fd9b1ac.webp";